import { render, staticRenderFns } from "./CVSelect.vue?vue&type=template&id=4a51edc4&scoped=true&"
import script from "./CVSelect.vue?vue&type=script&lang=js&"
export * from "./CVSelect.vue?vue&type=script&lang=js&"
import style0 from "./CVSelect.vue?vue&type=style&index=0&id=4a51edc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51edc4",
  null
  
)

export default component.exports